import { onValue, ref } from 'firebase/database';
import React, { useEffect, useState } from 'react';
import { realdb } from '../../config/firebase';
import { useTranslation } from 'react-i18next';
import { formatPrice } from '../../hooks/formatPrice';

const BidPrice = ({ id }) => {
    const { i18n } = useTranslation();
    const [bidPrice, setBidPrice] = useState('0');

    // fetch firebase data 
    useEffect(() => {
        if (!id) return;
        const productRef = ref(realdb, `products/${id}`);
        const unsubscribe = onValue(productRef, (snapshot) => {
            if (snapshot.exists()) {
                const data = snapshot.val();
                // console.log('Product Data:', data);
                if (data?.variants && Array.isArray(data?.variants)) {
                    const order = ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'];

                    const sortedArray = data?.variants?.sort((a, b) => {
                        return order.indexOf(a.size_name) - order.indexOf(b.size_name);
                    });
                    
                    setBidPrice(sortedArray[0] ? String(sortedArray[0]?.bid_amount) : '0');
                }
            } else {
                setBidPrice('0');
            }
        });
        return () => unsubscribe();
    }, [id]);

    return (
        <div>{formatPrice(bidPrice, i18n)}</div>
    )
};

export default BidPrice;
